const setExpanded = (name) => {
  // Set the data-expanded attribute for all containers controlled by this toggle:
  document.querySelectorAll(`[name="${name}"]`).forEach((toggleElement) => {
    const container = toggleElement.getAttribute('aria-controls');
    if (container !== null) {
      document.getElementById(toggleElement.getAttribute('aria-controls')).setAttribute(
        'data-expanded',
        '' + toggleElement.checked
      );
    }
  });
}

const setValueForGroup = (group, value) => {
  // Ensure all groups with the same identifier are set to the same value:
  document.querySelectorAll(`.js-image-toggle[data-radio-toggle-group="${group}"]`).forEach((toggleElement) => {
    if (toggleElement instanceof HTMLSelectElement) {
      toggleElement.value = value;
    } else if (toggleElement.value === value) {
      toggleElement.checked = true;
      setExpanded(toggleElement.name);
    }
  });
}

const toggleGroupNames = new Set();

document.querySelectorAll('.js-image-toggle').forEach((toggleElement) => {
  if (toggleElement.name !== '') {
    toggleGroupNames.add(toggleElement.name);
  }

  toggleElement.addEventListener('change', () => {
    setValueForGroup(toggleElement.dataset.radioToggleGroup, toggleElement.value);
  });
});

toggleGroupNames.forEach((groupName) => {
  setExpanded(groupName);
});
